"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariableWidgetToolbar = exports.VariableWidget = void 0;
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var react_addons_css_transition_group_1 = __importDefault(require("react-addons-css-transition-group"));
var utils_1 = require("@qwilr/kaleidoscope/utils");
var UniqueId_1 = __importDefault(require("@CommonFrontendBackend/Utils/UniqueId"));
var QwilrEditorTelemetry_1 = require("Project/QwilrEditor/QwilrEditorTelemetry");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var VariableWidget = (function (_super) {
    __extends(VariableWidget, _super);
    function VariableWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.closeToolbar = function () {
            _this.props.activeTokenToolbarStore.clearActiveVariableToolbar();
            _this.onClickOutside.stopListening();
        };
        _this.onClick = function () {
            _this.props.activeTokenToolbarStore.setActiveVariableToolbar(_this.variableWidgetId);
            _this.onClickOutside.startListening();
        };
        _this.variableWidgetId = "variable-".concat((0, UniqueId_1.default)());
        _this.onClickOutside = new utils_1.OnClickOutside([".variable-widget"], _this.closeToolbar);
        return _this;
    }
    Object.defineProperty(VariableWidget.prototype, "isSelected", {
        get: function () {
            return this.props.activeTokenToolbarStore.currentActiveVariableToolbarId === this.variableWidgetId;
        },
        enumerable: false,
        configurable: true
    });
    VariableWidget.prototype.componentDidMount = function () {
        this.extractWidgetSizes();
    };
    VariableWidget.prototype.render = function () {
        return (react_1.default.createElement("span", __assign({ contentEditable: false, onClick: this.onClick, className: (0, classnames_1.default)("variable-widget", {
                "variable-widget--selected": this.isSelected,
                "variable-widget--italic": this.isItalic(),
                "variable-widget--bold": this.isBold(),
                "variable-widget--strikethrough": this.isStrikethrough(),
            }) }, this.props.attributes),
            this.isSelected && this.renderMenu(),
            this.renderVariable()));
    };
    VariableWidget.prototype.renderVariable = function () {
        var _this = this;
        return (react_1.default.createElement("span", { className: "variable-name", ref: function (ref) {
                _this.variableWidgetElem = ref;
            } },
            this.props.variableLabel,
            this.props.children));
    };
    VariableWidget.prototype.renderMenu = function () {
        return (react_1.default.createElement(VariableWidgetToolbar, { variableItemWidth: this.variableItemWidth || 0, onDelete: this.onDelete, onItalic: this.onItalic, onBold: this.onBold, onStrikethrough: this.onStrikethrough, onMouseEnter: function () { }, onMouseLeave: function () { } }));
    };
    VariableWidget.prototype.triggerWidgetEventWithAction = function (action) {
        this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(EditorTypes_1.InlineType.Variable, {
            action: action,
            path: this.props.widgetManager.getPath(this.props.element),
        }));
    };
    VariableWidget.prototype.onDelete = function () {
        this.props.editorTelemetry.variableFormatted(QwilrEditorTelemetry_1.VariableFormatType.Delete);
        this.triggerWidgetEventWithAction(EditorTypes_1.VariableActionType.DeleteVariable);
    };
    VariableWidget.prototype.onBold = function () {
        this.props.editorTelemetry.variableFormatted(QwilrEditorTelemetry_1.VariableFormatType.Bold);
        this.triggerWidgetEventWithAction(EditorTypes_1.VariableActionType.Bold);
    };
    VariableWidget.prototype.onItalic = function () {
        this.props.editorTelemetry.variableFormatted(QwilrEditorTelemetry_1.VariableFormatType.Italic);
        this.triggerWidgetEventWithAction(EditorTypes_1.VariableActionType.Italic);
    };
    VariableWidget.prototype.onStrikethrough = function () {
        this.props.editorTelemetry.variableFormatted(QwilrEditorTelemetry_1.VariableFormatType.Strikethrough);
        this.triggerWidgetEventWithAction(EditorTypes_1.VariableActionType.Strikethrough);
    };
    VariableWidget.prototype.extractWidgetSizes = function () {
        try {
            var rect = this.variableWidgetElem.getBoundingClientRect();
            var width = rect.width;
            if (width != this.variableItemWidth) {
                this.variableItemWidth = width;
            }
        }
        catch (e) {
            console.error(e);
        }
    };
    VariableWidget.prototype.isItalic = function () {
        return this.props.isItalic;
    };
    VariableWidget.prototype.isBold = function () {
        return this.props.isBold;
    };
    VariableWidget.prototype.isStrikethrough = function () {
        return this.props.isStrikethrough;
    };
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], VariableWidget.prototype, "variableItemWidth", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], VariableWidget.prototype, "isSelected", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof EditorTypes_1.VariableActionType !== "undefined" && EditorTypes_1.VariableActionType) === "function" ? _a : Object]),
        __metadata("design:returntype", void 0)
    ], VariableWidget.prototype, "triggerWidgetEventWithAction", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VariableWidget.prototype, "onDelete", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VariableWidget.prototype, "onBold", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VariableWidget.prototype, "onItalic", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VariableWidget.prototype, "onStrikethrough", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VariableWidget.prototype, "extractWidgetSizes", null);
    VariableWidget = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], VariableWidget);
    return VariableWidget;
}(react_1.default.Component));
exports.VariableWidget = VariableWidget;
var VariableWidgetToolbar = (function (_super) {
    __extends(VariableWidgetToolbar, _super);
    function VariableWidgetToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VariableWidgetToolbar.prototype.render = function () {
        var _a = this.props, onDelete = _a.onDelete, onItalic = _a.onItalic, onBold = _a.onBold, onStrikethrough = _a.onStrikethrough, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
        var toolbarPositionStyle = {
            left: this.leftPositionOfToolbar,
        };
        return (react_1.default.createElement("span", { className: "editor-toolbar variable-widget__toolbar", style: toolbarPositionStyle },
            react_1.default.createElement(react_addons_css_transition_group_1.default, { transitionName: "fade", transitionEnterTimeout: 150, transitionLeaveTimeout: 150 },
                react_1.default.createElement("span", { className: "variable-widget__bold editor-toolbar__button", onMouseDown: onBold, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, contentEditable: false },
                    react_1.default.createElement(icons_1.Bold, null))),
            react_1.default.createElement(react_addons_css_transition_group_1.default, { transitionName: "fade", transitionEnterTimeout: 150, transitionLeaveTimeout: 150 },
                react_1.default.createElement("span", { className: "variable-widget__italic editor-toolbar__button", onMouseDown: onItalic, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, contentEditable: false },
                    react_1.default.createElement(icons_1.Italic, null))),
            react_1.default.createElement(react_addons_css_transition_group_1.default, { transitionName: "fade", transitionEnterTimeout: 150, transitionLeaveTimeout: 150 },
                react_1.default.createElement("span", { className: "variable-widget__strikethrough editor-toolbar__button", onMouseDown: onStrikethrough, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, contentEditable: false },
                    react_1.default.createElement(icons_1.Strikethrough, null))),
            react_1.default.createElement(react_addons_css_transition_group_1.default, { transitionName: "fade", transitionEnterTimeout: 150, transitionLeaveTimeout: 150 },
                react_1.default.createElement("span", { className: "variable-widget__deleter editor-toolbar__button", onMouseDown: function (event) {
                        event.preventDefault();
                        onDelete();
                    }, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, contentEditable: false },
                    react_1.default.createElement(icons_1.Delete, null)))));
    };
    Object.defineProperty(VariableWidgetToolbar.prototype, "leftPositionOfToolbar", {
        get: function () {
            var variableItemWidth = this.props.variableItemWidth;
            var toolbarWidth = 135;
            var leftPosition = (variableItemWidth - toolbarWidth) / 2;
            return "".concat(leftPosition, "px");
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], VariableWidgetToolbar.prototype, "leftPositionOfToolbar", null);
    VariableWidgetToolbar = __decorate([
        mobx_react_1.observer
    ], VariableWidgetToolbar);
    return VariableWidgetToolbar;
}(react_1.default.Component));
exports.VariableWidgetToolbar = VariableWidgetToolbar;
